<div class="container-fluid py-4">
  <div class="d-flex justify-content-between align-items-center gap-2 mb-4">
    <div>
      <h2 class="mb-1"><i class="fas fa-exchange-alt text-primary"></i> Perfil bancario</h2>
      <p class="text-muted mb-0">Con qué contrato bancario nacen los pagos de los botones y del Débito Inmediato</p>
    </div>
    <div class="d-flex gap-2">
      <button type="button" class="btn btn-outline-secondary" [disabled]="perfilLoading" (click)="loadPerfilBancario()">
        <i class="fas fa-sync-alt" [class.fa-spin]="perfilLoading"></i> Verificar
      </button>
      <a routerLink="/console/async-admin" class="btn btn-outline-primary"><i class="fas fa-arrow-left"></i> Pagos Asíncronos</a>
    </div>
  </div>

  <div *ngIf="!_auth.hasPermission('config.perfil_bancario.read')" class="alert alert-secondary">
    No tiene permiso para ver el perfil bancario.
  </div>

  <div *ngIf="_auth.hasPermission('config.perfil_bancario.read')" class="mb-3">
    <div class="kb-tabs">
      <button type="button" class="kb-tab" [ngClass]="{'kb-tab-activo': pestana === 'switch'}" (click)="pestana = 'switch'">Contrato activo</button>
      <button type="button" class="kb-tab" [ngClass]="{'kb-tab-activo': pestana === 'cuentas'}" (click)="pestana = 'cuentas'">Cuentas por contrato</button>
    </div>
  </div>

  <!-- Resultado del último cambio: lo que pasó con las cuentas -->
  <div *ngIf="resultadoCambio" class="kb-aviso mb-3" [ngClass]="resultadoCambio.tipo === 'alerta' ? 'kb-aviso-alerta' : 'kb-aviso-info'" id="resultado-cambio">
    <i class="fas" [ngClass]="resultadoCambio.tipo === 'alerta' ? 'fa-exclamation-triangle' : 'fa-check-circle'"></i>
    <div>{{ resultadoCambio.texto }}</div>
  </div>

  <div *ngIf="_auth.hasPermission('config.perfil_bancario.read')" class="row mb-4" [hidden]="pestana !== 'switch'">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div *ngIf="perfilError" class="alert alert-danger mb-3">
            <i class="fas fa-exclamation-triangle me-2"></i>{{ perfilError }}
          </div>

          <div *ngIf="perfilBancario" class="row">
            <!-- Estado y acción -->
            <div class="col-md-5 mb-3">
              <div class="p-3 border rounded">
                <div class="text-muted small">Perfil activo</div>
                <div class="perfil-activo">{{ perfilBancario.activo }}</div>
                <div class="text-muted small" *ngIf="perfilBancario.desde">desde {{ perfilBancario.desde | date:'dd/MM/yyyy HH:mm' }}</div>
                <p class="small text-muted mt-2 mb-3">
                  Decide con qué contrato nacen las transacciones nuevas del Botón BDV, del Botón Mercantil y del Débito Inmediato.
                  Las que están en curso terminan con su perfil. Pago móvil y transferencia se verifican según la cuenta que recibió el pago.
                </p>

                <button *ngIf="perfilBancario.activo !== perfilObjetivo" type="button" class="btn w-100" [ngClass]="puedeCambiarPerfil(perfilObjetivo) ? 'btn-primary' : 'btn-light border text-muted'"
                  [disabled]="!puedeCambiarPerfil(perfilObjetivo)" (click)="cambiarPerfilBancario(perfilObjetivo)">
                  <i class="fas fa-toggle-on me-1"></i> Pasar a {{ perfilObjetivo }}
                </button>
                <button *ngIf="perfilBancario.activo !== 'MT'" type="button" class="btn btn-outline-secondary w-100"
                  [disabled]="!puedeCambiarPerfil('MT')" (click)="cambiarPerfilBancario('MT')">
                  <i class="fas fa-undo me-1"></i> Volver a MT
                </button>

                <div class="small text-muted mt-2" *ngIf="!_auth.hasPermission('config.perfil_bancario.cambiar')">
                  Solo lectura: no tiene el permiso para cambiar el perfil.
                </div>
                <div class="small text-muted mt-2"
                  *ngIf="_auth.hasPermission('config.perfil_bancario.cambiar') && perfilBancario.activo !== perfilObjetivo && verificacionPerfil && !verificacionPerfil.listo">
                  El botón se habilita cuando todos los puntos de la verificación de {{ perfilObjetivo }} estén listos.
                </div>
              </div>
            </div>

            <!-- Verificación agrupada: qué se revisa, cuántos puntos están listos y qué falta -->
            <div class="col-md-7 mb-3" *ngIf="verificacionPerfil">
              <h6 class="fw-bold mb-1">
                ¿Está todo listo para pasar a {{ verificacionPerfil.perfil }}?
                <span class="badge ms-2" [ngClass]="verificacionPerfil.listo ? 'bg-success' : 'bg-warning text-dark'">
                  {{ verificacionPerfil.listo ? 'Listo' : 'Falta configurar' }}
                </span>
              </h6>
              <p class="small text-muted mb-2">El sistema revisa estos puntos antes de permitir el cambio.</p>
              <div *ngFor="let g of gruposVerificacion()" class="perfil-grupo">
                <div class="d-flex align-items-start gap-2">
                  <i class="fas mt-1" [ngClass]="g.listos === g.total ? 'fa-check-circle text-success' : 'fa-exclamation-circle text-warning'"></i>
                  <div class="flex-grow-1">
                    <div class="d-flex justify-content-between gap-2">
                      <strong>{{ g.titulo }}</strong>
                      <span class="small text-muted">{{ g.listos }} de {{ g.total }}</span>
                    </div>
                    <div class="small text-muted">{{ g.descripcion }}</div>
                    <div *ngIf="g.faltan.length && !g.claves" class="small mt-1">
                      <span class="fw-semibold">Falta:</span> {{ g.faltan.join(', ') }}.
                      <span *ngIf="g.solucion" class="text-muted">{{ g.solucion }}</span>
                    </div>
                    <!-- Claves: qué variable falta, en qué servicio y en qué servidor (sin valores) -->
                    <div *ngIf="g.faltan.length && g.claves" class="small mt-1">
                      <div class="fw-semibold">Variables por cargar:</div>
                      <div *ngFor="let f of variablesQueFaltan()" class="perfil-variables">
                        <span class="text-muted">{{ f.servidor }} · {{ f.servicio }}:</span>
                        <span *ngIf="f.error"> {{ f.error }}</span>
                        <code *ngFor="let v of f.variables">{{ v }}</code>
                      </div>
                      <div class="text-muted mt-1">Se cargan en las variables del servicio en Cloud Run o en su archivo de pm2 en la VM, y después se vuelve a verificar.</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Historial -->
          <div *ngIf="perfilBancario?.historia?.length" class="mt-2">
            <h6 class="fw-bold">Historial</h6>
            <div class="table-responsive">
              <table class="table table-sm align-middle mb-0">
                <thead>
                  <tr><th>Fecha</th><th>Cambio</th><th>Resultado</th><th>Usuario</th><th>Motivo</th></tr>
                </thead>
                <tbody>
                  <tr *ngFor="let h of perfilBancario.historia">
                    <td>{{ h.fecha | date:'dd/MM/yyyy HH:mm' }}</td>
                    <td>{{ h.de }} → {{ h.a }}</td>
                    <td><span class="badge" [ngClass]="h.resultado === 'APLICADO' ? 'bg-success' : 'bg-secondary'">{{ h.resultado === 'APLICADO' ? 'Aplicado' : 'Rechazado' }}</span></td>
                    <td>{{ h.usuario?.username || '—' }}</td>
                    <td>{{ h.motivo }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Cuentas por contrato: la vista de dos niveles (opciones de pago y sus cuentas), con borrador, bloqueos, guardado e historial -->
  <div *ngIf="_auth.hasPermission('config.perfil_bancario.read') && pestana === 'cuentas'" id="cuentas-por-contrato" class="mb-4">
    <app-cuentas-contrato [recarga]="recargaCuentas"></app-cuentas-contrato>
  </div>
</div>
